module.exports = __webpack_public_path__ + "img/login.8946100e.jpg";